// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-name-text {
  color: #000000;
  font-weight: 600;
  text-decoration: underline;
}

.job-detail-card-header {
  color: #fff;
  background-color: #ad728b;
  padding: 0.5rem 0.8rem;
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid #fff;
  min-width: 150px;
  display: flex;
  justify-content: center;
}

.job-header-status {
  padding: 0.5rem 0.8rem;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #000000;
  min-width: 150px;
  display: flex;
  justify-content: center;
}

.job-status-common {
  width: 90px;
  height: 26px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-header-search-admin__value-container {
  flex-wrap: nowrap !important;
}

.status-header-search__value-container {
  flex-wrap: nowrap !important;
}

.cs-badge-normal-hire {
  border: 1px solid #e0b5c6; /* Soft Pink */
  color: #e0b5c6 !important;
}

.cs-badge-active {
  border: 1px solid #6b3074; /* Deep Purple */
  color: #6b3074 !important;
}

.cs-badge-completed {
  border: 1px solid #4caf50; /* Green */
  color: #4caf50 !important;
}

.cs-badge-cancelled {
  border: 1px solid #e57373; /* Soft Red */
  color: #e57373 !important;
}

.cs-badge-expired {
  border: 1px solid #9e9e9e; /* Grey */
  color: #9e9e9e !important;
}

.cs-badge-in-progress {
  border: 1px solid #2196f3; /* Medium Blue */
  color: #2196f3 !important;
}

/* General Badge Style for Importance */
.cs-badge {
  border-radius: 12px;
  font-weight: bold;
  padding: 8px 12px;
  text-transform: uppercase;
  display: inline-block;
  margin: 4px;
}

/* Quick Hire Status */
.cs-badge-quickhire {
  border: 2px solid #f5a623; /* Warm Orange */
  color: #ffffff;
  background-color: #f5a623;
}

/* Normal Hire Status */
.cs-badge-normalhire {
  border: 2px solid #e0b5c6; /* Soft Pink */
  color: #ffffff;
  background-color: #e0b5c6;
}

/* Direct Hire Status */
.cs-badge-directhire {
  border: 2px solid #2196f3; /* Medium Blue */
  color: #ffffff;
  background-color: #2196f3;
}`, "",{"version":3,"sources":["webpack://./src/pages/JobListing/Style.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;AACJ;;AACA;EACI,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAEJ;;AACA;EACI,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,4BAAA;AAEJ;;AACA;EACI,4BAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,cAAA;EACA,yBAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,gBAAA;EACA,yBAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,UAAA;EACA,yBAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,aAAA;EACA,yBAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,SAAA;EACA,yBAAA;AAEJ;;AACA;EACI,yBAAA,EAAA,gBAAA;EACA,yBAAA;AAEJ;;AAAA,uCAAA;AACA;EACI,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AAGJ;;AAAA,sBAAA;AACA;EACI,yBAAA,EAAA,gBAAA;EACA,cAAA;EACA,yBAAA;AAGJ;;AAAA,uBAAA;AACA;EACI,yBAAA,EAAA,cAAA;EACA,cAAA;EACA,yBAAA;AAGJ;;AAAA,uBAAA;AACA;EACI,yBAAA,EAAA,gBAAA;EACA,cAAA;EACA,yBAAA;AAGJ","sourcesContent":[".profile-name-text {\n    color: #000000;\n    font-weight: 600;\n    text-decoration: underline;\n}\n.job-detail-card-header {\n    color: #fff;\n    background-color: #ad728b;\n    padding: 0.5rem 0.8rem;\n    border-radius: 30px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    border: 1px solid #fff;\n    min-width: 150px;\n    display: flex;\n    justify-content: center;\n}\n\n.job-header-status {\n    padding: 0.5rem 0.8rem;\n    border-radius: 30px;\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid #000000;\n    min-width: 150px;\n    display: flex;\n    justify-content: center;\n}\n\n.job-status-common {\n    width: 90px;\n    height: 26px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.status-header-search-admin__value-container {\n    flex-wrap: nowrap !important;\n}\n\n.status-header-search__value-container {\n    flex-wrap: nowrap !important;\n}\n\n.cs-badge-normal-hire {\n    border: 1px solid #e0b5c6; /* Soft Pink */\n    color: #e0b5c6 !important;\n}\n\n.cs-badge-active {\n    border: 1px solid #6b3074; /* Deep Purple */\n    color: #6b3074 !important;\n}\n\n.cs-badge-completed {\n    border: 1px solid #4caf50; /* Green */\n    color: #4caf50 !important;\n}\n\n.cs-badge-cancelled {\n    border: 1px solid #e57373; /* Soft Red */\n    color: #e57373 !important;\n}\n\n.cs-badge-expired {\n    border: 1px solid #9e9e9e; /* Grey */\n    color: #9e9e9e !important;\n}\n\n.cs-badge-in-progress {\n    border: 1px solid #2196f3; /* Medium Blue */\n    color: #2196f3 !important;\n}\n/* General Badge Style for Importance */\n.cs-badge {\n    border-radius: 12px;\n    font-weight: bold;\n    padding: 8px 12px;\n    text-transform: uppercase;\n    display: inline-block;\n    margin: 4px;\n}\n\n/* Quick Hire Status */\n.cs-badge-quickhire {\n    border: 2px solid #f5a623; /* Warm Orange */\n    color: #ffffff;\n    background-color: #f5a623;\n}\n\n/* Normal Hire Status */\n.cs-badge-normalhire {\n    border: 2px solid #e0b5c6; /* Soft Pink */\n    color: #ffffff;\n    background-color: #e0b5c6;\n}\n\n/* Direct Hire Status */\n.cs-badge-directhire {\n    border: 2px solid #2196f3; /* Medium Blue */\n    color: #ffffff;\n    background-color: #2196f3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
